import {
    LISTING_PRODUCT_CATEGORIES,
    LISTING_PRODUCT_CATEGORIES_SUCCESS,
    LISTING_PRODUCT_CATEGORIES_FAILED,
    ADDING_PRODUCT_CATEGORIES,
    ADDING_PRODUCT_CATEGORIES_SUCCESS,
    ADDING_PRODUCT_CATEGORIES_FAILED,
    DELETING_PRODUCT_CATEGORIES,
    DELETING_PRODUCT_CATEGORIES_SUCCESS,
    DELETING_PRODUCT_CATEGORIES_FAILED,
    UPDATING_PRODUCT_CATEGORIES,
    UPDATING_PRODUCT_CATEGORIES_SUCCESS,
    UPDATING_PRODUCT_CATEGORIES_FAILED,
    INFO_PRODUCT_CATEGORIES,
    INFO_PRODUCT_CATEGORIES_SUCCESS,
    INFO_PRODUCT_CATEGORIES_FAILED,
    RESET_PRODUCT_CATEGORIES_EDIT_STATE,
    RESET_PRODUCT_CATEGORIES_ADD_STATE,
    RESET_PRODUCT_CATEGORIES_INFO_STATE
} from "./actionTypes"


const INIT_STATE = {
    items: [],
    total: 0,
    item: null,
    isListing: false,
    isAdding: false,
    isDeleting: false,
    isUpdating: false,
    loadingInfo: false,
    listingErrorMessage: null,
    addingErrorMessage: null,
    deletingErrorMessage: null,
    updatingErrorMessage: null,
    infoErrorMessage: null,
    listingSuccessMessage: null,
    addingSuccessMessage: null,
    deletingSuccessMessage: null,
    updatingSuccessMessage: null,
    infoSuccessMessage: null,
}

const ProductCategory = (state = INIT_STATE, action) => {
    switch (action.type) {
        case LISTING_PRODUCT_CATEGORIES:
            return {
                ...state,
                items: [],
                total: 0,
                isListing: true,
                listingErrorMessage: null,
                listingSuccessMessage: null
            }
        case LISTING_PRODUCT_CATEGORIES_SUCCESS:
            const { items, total, message } = action.payload
            return {
                ...state,
                items: items,
                total: total,
                isListing: false,
                listingErrorMessage: null,
                listingSuccessMessage: message
            }
        case LISTING_PRODUCT_CATEGORIES_FAILED:
            return {
                ...state,
                items: [],
                total: 0,
                isListing: false,
                listingErrorMessage: action.payload,
                listingSuccessMessage: null
            }
        case ADDING_PRODUCT_CATEGORIES:
            return {
                ...state,
                isAdding: true,
                addingErrorMessage: null,
                addingSuccessMessage: null
            }
        case ADDING_PRODUCT_CATEGORIES_SUCCESS:
            return {
                ...state,
                isAdding: false,
                addingErrorMessage: null,
                addingSuccessMessage: action.payload
            }
        case ADDING_PRODUCT_CATEGORIES_FAILED:
            return {
                ...state,
                isAdding: false,
                addingErrorMessage: action.payload,
                addingSuccessMessage: null
            }
        case DELETING_PRODUCT_CATEGORIES:
            return {
                ...state,
                isDeleting: true,
                deletingErrorMessage: null,
                deletingSuccessMessage: null
            }
        case DELETING_PRODUCT_CATEGORIES_SUCCESS:
            return {
                ...state,
                isDeleting: false,
                deletingErrorMessage: null,
                deletingSuccessMessage: action.payload
            }
        case DELETING_PRODUCT_CATEGORIES_FAILED:
            return {
                ...state,
                isDeleting: false,
                deletingErrorMessage: action.payload,
                deletingSuccessMessage: null
            }
        case UPDATING_PRODUCT_CATEGORIES:
            return {
                ...state,
                isUpdating: true,
                updatingErrorMessage: null,
                updatingSuccessMessage: null
            }
        case UPDATING_PRODUCT_CATEGORIES_SUCCESS:
            return {
                ...state,
                isUpdating: false,
                updatingErrorMessage: null,
                updatingSuccessMessage: action.payload
            }
        case UPDATING_PRODUCT_CATEGORIES_FAILED:
            return {
                ...state,
                isUpdating: false,
                updatingErrorMessage: action.payload,
                updatingSuccessMessage: null
            }
        
        case INFO_PRODUCT_CATEGORIES:
            return {
                ...state,
                loadingInfo: true,
                item: null,
                infoErrorMessage: null,
                infoSuccessMessage: null
            }
        case INFO_PRODUCT_CATEGORIES_SUCCESS:
            return {
                ...state,
                loadingInfo: false,
                infoErrorMessage: null,
                item: action.payload,
                infoSuccessMessage: 'Product category details fetched successfully.'
            }
        case INFO_PRODUCT_CATEGORIES_FAILED:
            return {
                ...state,
                loadingInfo: false,
                item: null,
                infoErrorMessage: action.payload,
                infoSuccessMessage: null
            }
        case RESET_PRODUCT_CATEGORIES_EDIT_STATE:
            return {
                ...state,
                isUpdating: false,
                updatingErrorMessage: null,
                updatingSuccessMessage: null
            }
        case RESET_PRODUCT_CATEGORIES_ADD_STATE:
            return {
                ...state,
                isAdding: false,
                addingErrorMessage: null,
                addingSuccessMessage: null
            }
        case RESET_PRODUCT_CATEGORIES_INFO_STATE:
            return {
                ...state,
                loadingInfo: false,
                infoErrorMessage: null,
                infoSuccessMessage: null
            }
        default:
            return state
    }
}

export default ProductCategory